import React from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from 'react-router-dom';
import { generateRoutes } from '../../utils/route';
import { RouteName } from '../../utils/routeName';
import { ResetPassword } from './ResetPassword';

const ResetPasswordRouting = () => {
  const { t } = useTranslation(['global', 'routerName']);

  const routes = [
    {
      title: t('resetpassword'),
      key: 'resetpassword',
      link: RouteName.resetpassword,
      exact: true,
      component: () => <ResetPassword />,
    },
  ];

  return <Switch>{generateRoutes(routes)}</Switch>;
};

export default ResetPasswordRouting;
